module.exports = __webpack_public_path__ + "81f2c6ff5c94673f3f6615033d7abcee.pdf";